import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=29c52ea1&scoped=true&"
import script from "./Merchants.vue?vue&type=script&lang=js&"
export * from "./Merchants.vue?vue&type=script&lang=js&"
import style0 from "./Merchants.vue?vue&type=style&index=0&id=29c52ea1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c52ea1",
  null
  
)

export default component.exports